const almaFooter = {
    transferComplete(slotId) {
        let targetElement;
        let scripts;

        targetElement = document.createElement('div');
        targetElement.innerHTML = this.responseText;
        targetElement.setAttribute('id', `alma-content-router-target-${slotId}`);
        scripts = Array.prototype.slice.call(targetElement.getElementsByTagName('script'));
        document.body.appendChild(targetElement);
        scripts.forEach(function (script) {
            const scriptNode = document.createElement('script');
            scriptNode.text = script.text;
            document.body.appendChild(scriptNode);
            document.body.removeChild(scriptNode);
        });
    },
    transferFailed() {
        this.log('Transfer failed for loading content from Alma Content Router');
    },
    transferCanceled() {
        this.log('Transfer cancelled for loading content from Alma Content Router');
    },
    log(...args) {
        if ('console' in window && typeof window.console.log === 'function') {
            if (typeof window.console.error === 'function' && args[1] instanceof Error) {
                window.console.error(...args);
            } else {
                window.console.log(...args);
            }
        }
    },
    almaContentRouterRequest(slotId) {
        try {
            let url;
            let request;

            url = `https://almacrcommoncontent.net/${slotId}`;
            request = new XMLHttpRequest();
            request.addEventListener('load', this.transferComplete);
            request.addEventListener('error', this.transferFailed.bind(this));
            request.addEventListener('abort', this.transferCanceled.bind(this));
            request.open('GET', url);
            request.send();
        } catch (e) {
            this.log('Error loading content from Alma Content Router', e);
        }
    },
};

$(function () {
    almaFooter.almaContentRouterRequest('5577dbe2b922930e0c000022');
});
